import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { LinkContainer } from "react-router-bootstrap";
import { useState } from "react";
import OfferImg2 from "../../assets/Yoga_Matte.png";
import offerDescription from "../OfferDescription.jsx";
import {Kachel5} from "../Offer";
import SEO from "../SEO";

export default function Privatstunden() {
  const [matches, setMatches] = useState(window.innerWidth);
  window.addEventListener("resize", checkSize);

  function checkSize() {
    setMatches(window.innerWidth);
  }
  return (
    <>
      <SEO
          title="Private Yogastunden | Sylke Heuer"
          description="Individuelle private Yogastunden in Landsberg am Lech und Umgebung – persönlich, flexibel und auf deine Bedürfnisse abgestimmt."
      />
      <section className="offerSec">
        <h4 className="introHeader">{offerDescription[0].title}</h4>
        <div className="intro">{offerDescription[0].body}</div>
        <h2 id="offer">Angebot</h2>

          <Row lg={2} sm={12} className="g-4">
            <Col>
              <Card className="cardOfferHeight">
                <Card.Body>
                  <Card.Title>{Kachel5.header}</Card.Title>
                  <br/>
                  <Card.Text>
                    {Kachel5.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            {matches > 768 && (
            <Col>
              <Card.Img className="cardImageDetail" variant="top" src={OfferImg2} />
            </Col>
            )}
          </Row>
        <LinkContainer to={`/`}>
          <Button>Zurück</Button>
        </LinkContainer>
      </section>
    </>
  );
}
